import { FinanceCategory } from "../../../types/entities";
import { IconGlyph } from "../Icon";

/**
 * How each ledger category presents itself. The labels come from
 * finance/ledger.ts (which knows nothing about icons); this is the part that
 * only the screens need.
 */
export const CATEGORY_ICONS: Record<FinanceCategory, IconGlyph> = {
  primo: "piggy-bank",
  kontingent: "wallet",
  bode: "gavel",
  rente: "percent",
  arrangement: "champagne-glasses",
  gebyr: "building-columns",
  andet: "receipt",
};

/** Plural, for the month breakdown where a category heads a group of rows. */
export const CATEGORY_PLURALS: Record<FinanceCategory, string> = {
  primo: "Primo",
  kontingent: "Kontingenter",
  bode: "Bøder",
  rente: "Renter",
  arrangement: "Arrangementer",
  gebyr: "Gebyrer",
  andet: "Andet",
};
